import React, { createContext, useContext, useMemo } from 'react';

export const AssessmentContext = createContext(null);

export function AssessmentProvider({ assessment, children }) {
  return (
    <AssessmentContext.Provider value={assessment}>
      {children}
    </AssessmentContext.Provider>
  );
}

export function useAssessmentContext() {
  const assessment = useContext(AssessmentContext);
  return useMemo(
    () => ({
      assessment,
    }),
    [assessment]
  );
}

export default AssessmentProvider;
